import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { SwiggySmallIcon, ZomatoIcon } from "../../svgImage";

const HeaderNoteStrip = () => {
  const storeLink = process.env.REACT_APP_PRASADAM_STORE_LINK;
  const zomatoLink = "https://zomato.onelink.me/xqzv/mgiamoe8";
  const swiggyLink = "https://www.swiggy.com/menu/1106133?source=sharing";

  const handleOpenStore = (type) => {
    if (type === "orderNow") {
      window.location.href = storeLink;
    } else if (type === "zomato") {
      window.open(zomatoLink, "_blank");
    } else if (type === "swiggy") {
      window.open(swiggyLink, "_blank");
    }
  };

  return (
    <Grid container>
      <Grid size={12}>
        <div className={styles.marqueeContainer}>
          <div className={styles.marqueeTrack}>
            <div className={styles.marqueeItem}>
              <SwiggySmallIcon
                height="24px"
                width="24px"
                onClick={() => handleOpenStore("swiggy")}
              />
              We are live on Zomato and Swiggy
            </div>
            <div className={styles.marqueeItem}>
              <ZomatoIcon
                height="24px"
                width="24px"
                onClick={() => handleOpenStore("zomato")}
              />
              We are live on Zomato and Swiggy
            </div>
            {/* Repeat same content for seamless loop */}
            <div className={styles.marqueeItem}>
              <SwiggySmallIcon
                height="24px"
                width="24px"
                onClick={() => handleOpenStore("swiggy")}
              />
              We are live on Zomato and Swiggy
            </div>
            <div className={styles.marqueeItem}>
              <ZomatoIcon
                height="24px"
                width="24px"
                onClick={() => handleOpenStore("zomato")}
              />
              We are live on Zomato and Swiggy
            </div>

            <div className={styles.marqueeItem}>
              <SwiggySmallIcon
                height="24px"
                width="24px"
                onClick={() => handleOpenStore("swiggy")}
              />
              We are live on Zomato and Swiggy
            </div>
            <div className={styles.marqueeItem}>
              <ZomatoIcon
                height="24px"
                width="24px"
                onClick={() => handleOpenStore("zomato")}
              />
              We are live on Zomato and Swiggy
            </div>
            <div className={styles.marqueeItem}>
              <SwiggySmallIcon
                height="24px"
                width="24px"
                onClick={() => handleOpenStore("swiggy")}
              />
              We are live on Zomato and Swiggy
            </div>
            <div className={styles.marqueeItem}>
              <ZomatoIcon
                height="24px"
                width="24px"
                onClick={() => handleOpenStore("zomato")}
              />
              We are live on Zomato and Swiggy
            </div>
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default HeaderNoteStrip;
